import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import { Icon } from 'Components/UI';
import Modal from 'Components/UI/Modal';
import { Container } from './styles';

import PlanoAvisoObraUpgrade from 'Static/images/plano-aviso-obra-upgrade.png';

interface IAvisoObraUpgrade {
  visible?: boolean;
  order?: number;
  role?: number;
  planFree?: boolean;
  onConfirm: (role: number, order: number) => void;
  onCancel?: () => void;
}

const AvisoObraUpgrade: FC<IAvisoObraUpgrade> = ({
  visible,
  order,
  role,
  planFree,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('obras');

  return (
    <Modal
      footerButtons={false}
      visible={visible}
      width={'auto'}
      onCancel={onCancel}
    >
      <Container>
        <div className="imageWrapper">
          <img src={PlanoAvisoObraUpgrade} alt="" />
        </div>
        <div className={`contentWrapper ${!planFree ? 'contentWrapperPro' : ''}`}>
          <div>
            <label className="avisoLimiteObras">
              {planFree
                ? role === 1
                  ? t('avisoObraUpgrade.limitFreeAdmin')
                  : t('avisoObraUpgrade.limitFreeCompany')
                : role === 1
                  ? t('avisoObraUpgrade.limitPaidAdmin')
                  : t('avisoObraUpgrade.limitPaidCompany')
              }
            </label>
          </div>
          <h2>
            {planFree
              ? role === 1
                ? t('avisoObraUpgrade.upgradeFreeAdmin')
                : t('avisoObraUpgrade.upgradeFreeCompany')
              : role === 1
                ? t('avisoObraUpgrade.upgradePaidAdmin')
                : t('avisoObraUpgrade.upgradePaidCompany')
            }
          </h2>
          <h3>{t('avisoObraUpgrade.subtitle')}</h3>
          {planFree && (
            <>
              <p>{t('avisoObraUpgrade.premiumAlsoProvides')}</p>
              <div className="icons-wrapper">
                <div className="icons-text-wrapper icons-text-margin">
                  <div>
                    <Icon
                      icon="arquivo3d"
                      size="xs"
                      className="icons-text-wrapper-icon"
                      style={{ paddingLeft: 0, marginLeft: 0 }}
                    />
                    <span>{t('avisoObraUpgrade.feature2d3d')}</span>
                  </div>
                  <div>
                    <Icon
                      icon="estrelaVazia"
                      size="xs"
                      className="icons-text-wrapper-icon"
                      style={{ paddingLeft: 0, marginLeft: 0 }}
                    />
                    <span>{t('avisoObraUpgrade.featureNomenclature')}</span>
                  </div>
                </div>
                <div className="icons-text-wrapper">
                  <div>
                    <Icon
                      icon="menuGerenciarUsuario"
                      size="xs"
                      className="icons-text-wrapper-icon"
                    />
                    <span>{t('avisoObraUpgrade.featureUsersRoles')}</span>
                  </div>
                  <div>
                    <Icon
                      icon="menuPlotagem"
                      size="xs"
                      className="icons-text-wrapper-icon"
                    />
                    <span>{t('avisoObraUpgrade.featurePlotting')}</span>
                  </div>
                </div>
                <div style={{ marginBottom: 14 }}>&nbsp;</div>
              </div>
            </>
          )}

          <div className="button-wrapper">
            <Button
              className="button-cancel"
              type="link"
              width={190}
              height={48}
              onClick={onCancel}
            >
              {t('avisoObraUpgrade.maybeLater')}
            </Button>
            {order !== 4 && (
              <Button
                className="button-confirm"
                type='primary'
                ispremium="true"
                width={287}
                height={48}
                onClick={() => onConfirm(role || 0, order || 0)}
              >
                <Icon
                  icon="crown"
                  className="icon"
                  size="xxs"
                  color="cinzaEscuro"
                />
                {planFree && (role === 1
                  ? t('avisoObraUpgrade.acquirePremium')
                  : t('avisoObraUpgrade.requestPremium')
                )}
                {!planFree && (
                  order === 2
                    ? (role === 1 ? t('avisoObraUpgrade.acquireProRequest') : t('avisoObraUpgrade.requestProRequest'))
                    : (role === 1 ? t('avisoObraUpgrade.acquireEnterpriseRequest') : t('avisoObraUpgrade.requestEnterpriseRequest'))
                )}
              </Button>
            )}
            {order === 4 && (
              <Button
                className="button-cancel"
                type="primary"
                width={210}
                height={48}
                onClick={() => onConfirm(role || 0, order)}
              >
                {t('avisoObraUpgrade.requestMoreObras')}
              </Button>
            )}
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default AvisoObraUpgrade;
